import type { MaybeRefOrGetter } from "vue";
import { getTaxonList } from "@carnet/api/backoffice";
import type { SpecieTaxonNameResource } from "@carnet/api/backoffice";

export async function useTaxonNames(taxonIds: MaybeRefOrGetter<string[]>) {
  const sortedIds = computed(() => Array.from(new Set(toValue(taxonIds))).sort());

  const { data } = await useAsyncData<SpecieTaxonNameResource[]>(
    () => `taxon-names-${sortedIds.value.join("-") || "none"}`,
    async () => {
      const ids = sortedIds.value;
      if (!ids.length) return [];
      const response = await getTaxonList({
        composable: "$fetch",
        path: { locale: appLocale() },
        query: { "ids[]": ids.map(Number) },
      });
      return response?.data?.list ?? [];
    }
  );

  return computed<Record<string, string>>(() => {
    const map: Record<string, string> = {};
    for (const taxon of data.value ?? []) map[String(taxon.id)] = taxon.name;
    return map;
  });
}
